import Vue from "vue";
import { mapGetters, mapActions } from "vuex";

Vue.component("coin-component", {
  template: `<div class="c-coin">
                <div class="c-coin-header">
                  <h1 class="c-coin-header-title" v-bind:class="activeView.lang" v-html="activeView.title"></h1>
                </div> 
              <div class="c-coin-animation start-animation">
                <div class="c-coin-animation-shake">
                    <span></span> 
                </div>
              </div>
              <div v-html="activeView.intro" class="c-coin-info" v-bind:class="activeView.lang"></div>
              <div class="c-coin-buttons">
                <a class="btn prominent btn-l2" v-on:click.stop.prevent="guess(0)" href="#">{{ activeView.btn_black }}</a>
                <a class="btn prominent btn-l3" v-on:click.stop.prevent="guess(1)" href="#">{{ activeView.btn_yellow }}</a>
              </div>
              <div class="c-coin-significant-terms">
                {{ activeView.significant_terms }}
              </div>
            </div>`,
  computed: {
    ...mapGetters({
      activeView: "activeView"
    })
  },
  methods: {
    guess(val) {
      const buttons = document.querySelector(".c-coin-buttons");
      buttons.classList.add("disable");
      if (val === 0) {
        this.$emit("notify", "black");
        dataLayer.push({
          event: "Event.Functionality.",
          "page.referringAction": "coin-flip_Black_Clicked"
        });
      } else if (val === 1) {
        this.$emit("notify", "yellow");
        dataLayer.push({
          event: "Event.Functionality.",
          "page.referringAction": "coin-flip_Yellow_Clicked"
        });
      }
    },
    check() {
      var animation = document.querySelector(".c-coin-animation");
      animation.classList.remove("start-animation");
      animation.classList.remove("flipyellow");
      animation.classList.add("flipblack");
    }
  }
});



// WEBPACK FOOTER //
// ./app/js/components/coin-component.js